import { render, staticRenderFns } from "./SignDialog.vue?vue&type=template&id=de8c5268&scoped=true"
import script from "./SignDialog.vue?vue&type=script&lang=js"
export * from "./SignDialog.vue?vue&type=script&lang=js"
import style0 from "./SignDialog.vue?vue&type=style&index=0&id=de8c5268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8c5268",
  null
  
)

export default component.exports